import React, { useEffect, useState } from "react";
import type { NextPage } from "next";
import Image from "next/image";
import Link from "next/link";
import Layout from "@/layout/layout";
import WEDDINGbg from "@/assets/images/WEDDING_bg.png";
import logo from "@/assets/images/logowedding.png";
import wed1 from "@/assets/images/wed1.png";
import wed2 from "@/assets/images/wed2.png";
import wed3 from "@/assets/images/wed3.png";
import wedLine from "@/assets/images/wed-line.png";
import wed4b from "@/assets/images/wed4b.png";
import wed5b from "@/assets/images/wed5d.png";
import bootomwed from "@/assets/images/bootom-wed.png";
import styles from "./weddingoffer.module.scss";

import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import endpoints from "@/api/endpoints";
import httpClient from "@/api/http-client";
import { useRouter } from "next/router";

const SencoDiWedding: NextPage = () => {
  const router = useRouter();
  const [states, setStates] = useState<any[]>([]);

  const formik = useFormik({
    initialValues: {
      full_name: "",
      partner_name: "",
      contact_number: "",
      email_address: "",
      expected_wedding_date: "",
      tentative_budget: "",
      state: "",
      city: "",
      invoice_number: "",
      customer_id: "",
      terms_accepted: false,
    },
    validationSchema: Yup.object({
      full_name: Yup.string()
        .trim()
        .min(2, "Full name must be at least 2 characters")
        .required("Full name is required"),
      partner_name: Yup.string()
        .trim()
        .min(2, "Partner name must be at least 2 characters")
        .required("Partner name is required"),
      contact_number: Yup.string()
        .required("Contact number is required")
        .matches(/^[0-9]{10}$/, "Enter a valid 10 digit mobile number"),
      email_address: Yup.string()
        .email("Enter a valid email address")
        .required("Email address is required"),
      expected_wedding_date: Yup.string().required(
        "Expected wedding date is required"
      ),
      tentative_budget: Yup.string()
        .required("Tentative budget is required")
        .oneOf(
          [
            "100000-200000",
            "200000-500000",
            "500000-1000000",
            "1000000-1500000",
            "1500000-999999999",
          ],
          "Please select a valid budget slab"
        ),
      state: Yup.string().required("State is required"),
      city: Yup.string()
        .trim()
        .min(2, "City must be at least 2 characters")
        .required("City is required"),
      invoice_number: Yup.string().trim(),
      customer_id: Yup.string().trim(),
      terms_accepted: Yup.boolean()
        .required("You must accept the terms and conditions")
        .oneOf([true], "You must accept the terms and conditions"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      // format date from yyyy-mm-dd to dd-mm-yyyy if needed
      const dateParts = values.expected_wedding_date
        ? values.expected_wedding_date.split("-")
        : [];
      const formattedDate =
        dateParts.length === 3
          ? `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
          : values.expected_wedding_date;

      const payload = {
        full_name: values.full_name,
        partner_name: values.partner_name,
        contact_number: values.contact_number,
        email_address: values.email_address,
        expected_wedding_date: formattedDate,
        tentative_budget: values.tentative_budget,
        state: values.state,
        city: values.city,
        invoice_number: values.invoice_number,
        customer_id: values.customer_id,
      };

      try {
        const { data } = await httpClient.post(endpoints.wedding(), payload);
        if (data?.status === false) {
          toast.error(data?.message || "Failed to submit. Please try again.");
        } else {
          toast.success("Submitted successfully. Thank you!");
          formik.resetForm();
          router.push("/");
        }
      } catch (err: any) {
        console.error("Network error:", err);
        toast.error(
          err.response?.data?.message || "Failed to submit. Please try again."
        );
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    const loadStates = async () => {
      try {
        const { data } = await httpClient.get(endpoints.state("IND"));
        setStates(data?.data ?? []);
      } catch (err) {
        console.error("Failed to load states:", err);
      }
    };
    loadStates();
  }, []);

  return (
    <Layout>
      <div className="container">
        <div className={styles.weddingbg}>
          <div className={styles.image_container}>
            <div className={styles.img}>
              <Image src={WEDDINGbg} alt="" />
            </div>
            <div className={styles.form_container}>
              <div className="row g-3">
                <div className="col-xl-6"></div>
                <div className="col-xl-6">
                  <div className={styles.bg}>
                    <div className={styles.logo}>
                      <Image src={logo} width={200} height={107} alt="logo" />
                    </div>
                    <p className={styles.subtitle}>
                      Getting married soon? Enrol now to enjoy exclusive
                      experiences.
                    </p>
                    <fieldset>
                      <legend>Stand a Chance to Win!</legend>
                      <div className={styles.fieldset}>
                        <div className={styles.group_text}>
                          <ul>
                            <li>
                              <figure>
                                <Image src={wed1} alt="" />
                              </figure>
                              <div className={styles.offerItem}>
                                Honeymoon
                                <br /> Experiences
                              </div>
                            </li>
                            <li>
                              <figure>
                                <Image src={wed2} alt="" />
                              </figure>
                              <div className={styles.offerItem}>
                                5-Star <br /> Culinary Delight
                              </div>
                            </li>
                            <li>
                              <figure>
                                <Image src={wed3} alt="" />
                              </figure>
                              <div className={styles.offerItem}>
                                Pre-Wedding Shoots
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className={styles.line}>
                          <Image src={wedLine} alt="" />
                        </div>
                        <div className={styles.bump}>
                          <span>Bumper Offer: Jewellery Voucher worth</span>
                          <strong>₹10 Lakhs!</strong>
                        </div>
                        <div className={styles.line}>
                          <Image src={wedLine} alt="" />
                        </div>
                      </div>
                      <div className={styles.legend_bottom1}>
                        <div className={styles.promoStrip}>
                          <ul className={styles.inner}>
                            <li className={styles.card}>
                              <div className={styles.heading}>
                                GOLD JEWELLERY
                              </div>
                              <div className={styles.highlightRow}>
                                <div className={styles.highlight}>
                                  <small>UP TO</small>{" "}
                                  <div className="d-flex">
                                    <strong>35</strong>{" "}
                                    <div>
                                      % <br />
                                      <span>OFF</span>
                                    </div>{" "}
                                  </div>
                                  <div className={styles.sub}>
                                    On Making Charges
                                  </div>
                                </div>
                              </div>
                            </li>

                            <li className={styles.card}>
                              <div className={styles.heading}>
                                DIAMOND JEWELLERY
                              </div>
                              <div className={styles.highlightRow}>
                                <div className={styles.highlight}>
                                  <small>UP TO</small>{" "}
                                  <div className="d-flex">
                                    <strong>20</strong>{" "}
                                    <div>
                                      % <br />
                                      <span>OFF</span>
                                    </div>{" "}
                                  </div>
                                  <div className={styles.sub}>
                                    On <br />
                                    Value
                                  </div>
                                </div>
                              </div>
                            </li>

                            <li className={styles.card}>
                              <div className={styles.heading}></div>

                              <div className={styles.highlightRow}>
                                <div className={styles.highlight}>
                                  <div className="d-flex">
                                    <strong>0%</strong>
                                  </div>
                                  <div className={styles.sub}>
                                    {" "}
                                    Deduction On Old Gold Exchange
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </fieldset>

                    <form
                      onSubmit={formik.handleSubmit}
                      className={styles.form_container_main}
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-2">
                            <label className="form-label">
                              Full Name <sup>*</sup>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="full_name"
                              name="full_name"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.full_name}
                            />
                            {formik.touched.full_name &&
                            formik.errors.full_name ? (
                              <small className="text-danger">
                                {formik.errors.full_name}
                              </small>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-2">
                            <label className="form-label">
                              Partner&apos;s Name <sup>*</sup>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="partner_name"
                              name="partner_name"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.partner_name}
                            />
                            {formik.touched.partner_name &&
                            formik.errors.partner_name ? (
                              <small className="text-danger">
                                {formik.errors.partner_name}
                              </small>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-2">
                            <label className="form-label">
                              Contact Number <sup>*</sup>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="contact_number"
                              name="contact_number"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.contact_number}
                              placeholder="10 digit mobile"
                            />
                            {formik.touched.contact_number &&
                            formik.errors.contact_number ? (
                              <small className="text-danger">
                                {formik.errors.contact_number}
                              </small>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-2">
                            <label className="form-label">
                              Email Address <sup>*</sup>
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="email_address"
                              name="email_address"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.email_address}
                            />
                            {formik.touched.email_address &&
                            formik.errors.email_address ? (
                              <small className="text-danger">
                                {formik.errors.email_address}
                              </small>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-2">
                            <label className="form-label">
                              Expected Wedding Date <sup>*</sup>
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              id="expected_wedding_date"
                              name="expected_wedding_date"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.expected_wedding_date}
                            />
                            {formik.touched.expected_wedding_date &&
                            formik.errors.expected_wedding_date ? (
                              <small className="text-danger">
                                {formik.errors.expected_wedding_date}
                              </small>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-2">
                            <label className="form-label">
                              Tentative Budget for Jewellery <sup>*</sup>
                            </label>
                            <select
                              className="form-control"
                              id="tentative_budget"
                              name="tentative_budget"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.tentative_budget}
                            >
                              <option value="">Select Budget Slab</option>
                              <option value="100000-200000">1-2Lakh</option>
                              <option value="200000-500000">2-5Lakhs</option>
                              <option value="500000-1000000">5-10 Lakhs</option>
                              <option value="1000000-1500000">
                                10-15Lakhs
                              </option>
                              <option value="1500000-999999999">
                                Above 15 Lakhs
                              </option>
                            </select>
                            {formik.touched.tentative_budget &&
                            formik.errors.tentative_budget ? (
                              <small className="text-danger">
                                {formik.errors.tentative_budget}
                              </small>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-2">
                            <label className="form-label">
                              State <sup>*</sup>
                            </label>
                            <select
                              className="form-control"
                              id="state"
                              name="state"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.state}
                            >
                              <option value="">Select State</option>
                              {states.map((v: any) => (
                                <option value={v.name} key={v.code}>
                                  {v.name}
                                </option>
                              ))}
                            </select>
                            {formik.touched.state && formik.errors.state ? (
                              <small className="text-danger">
                                {formik.errors.state}
                              </small>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-2">
                            <label className="form-label">
                              City <sup>*</sup>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="city"
                              name="city"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.city}
                              placeholder="Enter city"
                            />
                            {formik.touched.city && formik.errors.city ? (
                              <small className="text-danger">
                                {formik.errors.city}
                              </small>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-2">
                            <label className="form-label">Invoice Number</label>
                            <input
                              type="text"
                              className="form-control"
                              id="invoice_number"
                              name="invoice_number"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.invoice_number}
                              placeholder=""
                            />
                            {formik.touched.invoice_number &&
                            formik.errors.invoice_number ? (
                              <small className="text-danger">
                                {formik.errors.invoice_number}
                              </small>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-2">
                            <label className="form-label">Customer ID</label>
                            <input
                              type="text"
                              className="form-control"
                              id="customer_id"
                              name="customer_id"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.customer_id}
                              placeholder=""
                            />
                            {formik.touched.customer_id &&
                            formik.errors.customer_id ? (
                              <small className="text-danger">
                                {formik.errors.customer_id}
                              </small>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="mb-3">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="terms_accepted"
                                name="terms_accepted"
                                checked={formik.values.terms_accepted}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="terms_accepted"
                              >
                                I agree to the{" "}
                                <Link href="/senco-di-wedding-t-and-c">
                                  <a style={{ fontWeight: "bold" }} onMouseEnter={e => (e.currentTarget.style.color = "red")} onMouseLeave={e => (e.currentTarget.style.color = "")}>Terms & Conditions</a>
                                </Link>{" "}
                                <sup>*</sup>
                              </label>
                            </div>
                            {formik.touched.terms_accepted &&
                            formik.errors.terms_accepted ? (
                              <small className="text-danger d-block">
                                {formik.errors.terms_accepted}
                              </small>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className={styles.bottom_button}>
                        <div>
                          <Image src={wed4b} alt="" />{" "}
                        </div>
                        <button type="submit" disabled={formik.isSubmitting}>
                          {formik.isSubmitting ? "Submitting..." : "SUBMIT"}
                        </button>
                        <div>
                          <Image src={wed5b} alt="" />{" "}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SencoDiWedding;
